import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-slider-value',
  templateUrl: './slider-value.component.html',
  styleUrls: ['./slider-value.component.scss']
})
export class SliderValueComponent implements OnInit, OnChanges {
  @ViewChild('svgTrack') svgTrack!: ElementRef<SVGSVGElement>;

  @Input() value: any;
  @Output() valueChange = new EventEmitter<number>();
  @Output() angleChanged = new EventEmitter<number>();
  transformX = -10;

  private isDragging = false;
  private startX = 0;
  private startAngle = 0;
  
  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('changes', changes)
    if (changes.value.currentValue == 0 && this.transformX != -10) {
      this.transformX = -10
    }
  }
  
  onMouseDown(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.startX = event.clientX;
    this.startAngle = this.value;
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;

    const deltaX = event.clientX - this.startX;
    let newAngle = this.startAngle + deltaX / 2; // чувствительность

    // Ограничим до -180...180
    if (newAngle > 45) newAngle = 45;
    if (newAngle < -45) newAngle = -45;

    // Магнит к 0°
    // if (Math.abs(newAngle) < 2) newAngle = 0;

    this.value = Math.round(newAngle);
    this.valueChange.emit(this.value);
    this.angleChanged.emit(this.value);
    this.transformX = -10 + (-this.value * 4.5); // -4px на каждый градус

    // -190;
    // 170

    // -210
    // +190
  }

  reset() {
    this.value = 0;
    this.valueChange.emit(this.value);
    this.angleChanged.emit(this.value);
    this.transformX = -10;
  }
}
